<template>
  <div style="max-width: 1200px; margin: 0 auto;">
    <div class="dashboard-title dashboard-title--basic mb-lg">
      <div class="dashboard-title__actions">
        <div>
          <h1 class="fw-bold fs-xl mb-xs">
            Our public profiles
          </h1>
          <p class="fc-darker fs-md mr-lg">
            Manage your profile and leads
          </p>
        </div>
      </div>
    </div>
    <template v-if="loading">
      <Logo />
    </template>
    <template v-else>
      <TableToolbar :query="filters.name.value" @update-query="filterRows">
        <div>
          <label style="margin-bottom: 0" class="mr-xs">
            <div class="select select-mb-0">
              <select
                @change="filterRows(['status'], $event.target.value, 'status')"
              >
                <option selected="selected" value>Status</option>
                <option :selected="filters.status.value === 'P'" value="P"
                  >Public</option
                >
                <option :selected="filters.status.value === 'S'" value="S"
                  >Searchable</option
                >
                <option :selected="filters.status.value === 'H'" value="H"
                  >Hidden</option
                >
                <option :selected="filters.status.value === 'I'" value="I"
                  >Invited</option
                >
              </select>
            </div>
          </label>
          <label style="margin-bottom: 0">
            <div class="select select-mb-0">
              <select
                @change="
                  filterRows(
                    ['completeness'],
                    $event.target.value,
                    'completeness'
                  )
                "
              >
                <option selected="selected" value>Completeness</option>
                <option :selected="filters.completeness.value == 20" value="20"
                  >20%</option
                >
                <option :selected="filters.completeness.value == 40" value="40"
                  >40%</option
                >
                <option :selected="filters.completeness.value == 60" value="60"
                  >60%</option
                >
                <option :selected="filters.completeness.value == 80" value="80"
                  >80%</option
                >
                <option
                  :selected="filters.completeness.value == 100"
                  value="100"
                  >100%</option
                >
              </select>
            </div>
          </label>
        </div>
      </TableToolbar>
      <div class="mb-lg">
        <v-table
          key="x"
          :data="rows"
          :filters="filters"
          :currentPage.sync="currentPage"
          :pageSize="pageSize"
          :totalItemsInput="count"
          class="table table-bordered"
          @totalPagesChanges="totalPages = $event"
        >
          <thead slot="head">
            <v-th
              v-on:sortChange="sortChange"
              v-for="(column, i) in columns"
              :key="i"
              :defaultSort="column.name === 'vendorName' ? 'asc' : undefined"
              :customSort="
                column.name === 'vendorName' ? sortVendors : undefined
              "
              :sortKey="column.name"
              :hideCustomSortIcon="column.name === 'tierName'"
              class="mb-xxs relative grey-background fs-sm"
            >
              <svg
                @click="showModal(true)"
                class="absolute cursor-pointer"
                style="left: -3px; top: 16px;"
                v-if="column.name === 'completeness'"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.4001 7.99998C14.4001 9.69736 13.7258 11.3252 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3252 1.6001 9.69736 1.6001 7.99998C1.6001 6.30259 2.27438 4.67472 3.47461 3.47449C4.67485 2.27426 6.30271 1.59998 8.0001 1.59998C9.69748 1.59998 11.3253 2.27426 12.5256 3.47449C13.7258 4.67472 14.4001 6.30259 14.4001 7.99998ZM8.8001 4.79998C8.8001 5.01215 8.71581 5.21563 8.56578 5.36566C8.41575 5.51569 8.21227 5.59998 8.0001 5.59998C7.78792 5.59998 7.58444 5.51569 7.43441 5.36566C7.28438 5.21563 7.2001 5.01215 7.2001 4.79998C7.2001 4.5878 7.28438 4.38432 7.43441 4.23429C7.58444 4.08426 7.78792 3.99998 8.0001 3.99998C8.21227 3.99998 8.41575 4.08426 8.56578 4.23429C8.71581 4.38432 8.8001 4.5878 8.8001 4.79998ZM7.2001 7.19998C6.98792 7.19998 6.78444 7.28426 6.63441 7.43429C6.48438 7.58432 6.4001 7.7878 6.4001 7.99998C6.4001 8.21215 6.48438 8.41563 6.63441 8.56566C6.78444 8.71569 6.98792 8.79998 7.2001 8.79998V11.2C7.2001 11.4121 7.28438 11.6156 7.43441 11.7657C7.58444 11.9157 7.78792 12 8.0001 12H8.8001C9.01227 12 9.21575 11.9157 9.36578 11.7657C9.51581 11.6156 9.6001 11.4121 9.6001 11.2C9.6001 10.9878 9.51581 10.7843 9.36578 10.6343C9.21575 10.4843 9.01227 10.4 8.8001 10.4V7.99998C8.8001 7.7878 8.71581 7.58432 8.56578 7.43429C8.41575 7.28426 8.21227 7.19998 8.0001 7.19998H7.2001Z"
                  fill="#363D4D"
                />
              </svg>
              {{ column.displayName }}
            </v-th>
          </thead>
          <tbody
            slot="body"
            slot-scope="{ displayData }"
            v-if="displayData.length"
          >
            <tr
              style="z-index: 0"
              v-for="(row, i) in displayData"
              :key="i"
              @click="
                $helpers.navigateOrNewTab(getDirectoryUrl(row), $router, $event)
              "
            >
              <td class="fs-sm fw-semibold">
                {{ row.vendorName || row.name }}
              </td>
              <td class="fs-sm f-capitalize">
                {{ row.tierName | tier }}
              </td>
              <td class="fs-sm relative">
                <div class="block" style="max-width: fit-content;">
                  <i
                    class="fa fa-circle mr-xs"
                    :class="row.status | circleClass"
                  />
                  {{ row.status | status }}
                </div>
              </td>
              <td class="fs-sm relative">
                <div class="block pl-8" style="max-width: fit-content;">
                  {{
                    (row.completeness || '-') + (row.completeness ? '%' : '')
                  }}
                </div>
              </td>
            </tr>
          </tbody>
          <tbody
            style="padding: 1em; display: block"
            class="fs-sm fw-semibold fc-medium"
            v-else
          >
            No partners!
          </tbody>
        </v-table>
        <smart-pagination
          :currentPage.sync="currentPage"
          :count="count"
          :pageSize="pageSize"
          v-on:update:currentPage="pageChanged($event)"
          :boundaryLinks="count > 50"
        />
      </div>
      <ProfileCompletenessModal
        :modalShowing="modalShowing"
        @show-modal="showModal"
      />
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TableToolbar from '@/components/Dashboard/TableToolbar';
import { filtersOptions } from '@/views/AgencyDashboard/OurPublicProfiles/FiltersOptions';
import ProfileCompletenessModal from '@/views/AgencyDashboard/OurPublicProfiles/ProfileCompletenessModal';
import Logo from '@/components/SpinningLogo';
const {
  mapActions,
  mapGetters,
  mapState,
  mapMutations,
} = createNamespacedHelpers('ourPublicProfiles');

export default {
  computed: {
    ...mapGetters({
      filters: 'getFilters',
      rows: 'getRows',
      columns: 'getColumns',
    }),
    ...mapState(['pageSize', 'count', 'query', 'loading']),
    totalPages() {
      return Math.ceil(this.count / this.pageSize);
    },
  },
  components: {
    Logo,
    ProfileCompletenessModal,
    TableToolbar,
  },
  data() {
    return {
      currentPage: 1,
      modalShowing: false,
    };
  },
  created() {
    this.setSort('-created');
    this.fetchOurPublicProfiles(1);
  },
  filters: {
    ...filtersOptions,
  },
  methods: {
    ...mapActions([
      'fetchOurPublicProfiles',
      'updateQueryAndFilter',
      'sortResults',
    ]),
    ...mapMutations(['setSort']),
    pageChanged(page) {
      this.fetchOurPublicProfiles(page);
    },
    getDirectoryUrl(directory) {
      return `/agency/our-public-profiles/${directory.id}`;
    },
    filterRows(fields, value, type) {
      if (!fields && type === 'name') {
        fields = ['vendorName', 'name'];
      }
      const exact = false;
      this.currentPage = 1;
      this.updateQueryAndFilter({ fields, value, type, exact });
    },
    sortChange(key) {
      this.sortResults(key);
      this.currentPage = 1;
    },
    sortVendors(a, b) {
      const first = a.vendorName || a.name;
      const second = b.vendorName || b.name;

      if (!first && second) return 1;
      if (second && !first) return -1;
      if (!first && !second) return 1;

      return first.localeCompare(second, undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    },
    showModal(value) {
      this.modalShowing = value;
    },
  },
};
</script>
<style scoped>
.partnerpage .grid {
  margin-left: -0.8rem;
}
</style>
